import React, { useEffect, useState } from "react";
import { Container, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";

import apiClient from "../../axiosInstance";
import TanstackTable from "../../components/Common/TanstackTable";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import showAlert from "../../components/Common/ShowAlert";
import Swal from "sweetalert2";

const ExpenseTypesList = () => {
  const [breadcrumbItems] = useState([
    { title: "Daryeel", link: "/" },
    { title: "Expense Types", link: "#" },
  ]);

  const [data, setData] = useState([]);

  const fetchExpenseTypes = async () => {
    try {
      const result = await apiClient.get("/expense/types");
      setData(result.data.response || []);
    } catch (err) {
      console.error("Error fetching expense types:", err);
    }
  };

  useEffect(() => {
    fetchExpenseTypes();
  }, []);

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Delete Expense Type",
      text: "Are you sure you want to delete this expense type?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
      cancelButtonText: "Cancel",
    });

    if (!confirm.isConfirmed) return;

    try {
      const res = await apiClient.delete(`/expense/types/${id}`);
      await showAlert({
        title: "Expense Type",
        text: res.data.message || "Deleted",
        icon: res.data.status || "success",
      });
      fetchExpenseTypes();
    } catch (err) {
      console.error("Error deleting expense type:", err);
      await showAlert({
        title: "Expense Type",
        text:
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Failed to delete expense type",
        icon: "error",
      });
    }
  };

  const columns = [
    {
      id: "index",
      header: "No",
      cell: ({ row }) => row.index + 1,
    },
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "description",
      header: "Description",
    },
    {
      accessorKey: "created_by_name",
      header: "Created By",
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <div className="d-flex gap-2">
          <Link
            to={`/expenseTypes/${row.original.id}`}
            className="btn btn-sm btn-primary"
          >
            <i className="ri-file-edit-line"></i>
          </Link>
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(row.original.id)}
          >
            <i className="ri-delete-bin-line"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Expense Types" breadcrumbItems={breadcrumbItems} />
        <Card>
          <CardBody>
            <div className="row">
              <div className="col-12 text-end mb-2">
                <Link to="/createExpenseType">
                  <button className="btn btn-primary">
                    Create Expense Type
                  </button>
                </Link>
              </div>
            </div>
            <TanstackTable data={data} columns={columns} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default ExpenseTypesList;
